import { render } from "./EditTextarea.vue?vue&type=template&id=60bf5296&scoped=true"
import script from "./EditTextarea.vue?vue&type=script&lang=js"
export * from "./EditTextarea.vue?vue&type=script&lang=js"

import "./EditTextarea.vue?vue&type=style&index=0&id=60bf5296&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60bf5296"]])

export default __exports__